import './App.css';
import './Themes/light-theme.css';
import './Themes/dark-theme.css';
import Homepage from './components/pages/Homepage/Homepage';
import Login from './components/pages/Login/Login';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { ToastContainer } from 'react-toastify';
import Talkpage from './components/pages/Talkpage/Talkpage';
import TalkDetails from './components/pages/TalkDetails/TalkDetails';
import { useEffect } from 'react';
import SubmitSummaryPage from './components/pages/SubmitSummaryPage/SubmitSummaryPage';
import TechniquePage from './components/pages/TechniquePage/TechniquePage';
import TechniqueDetails from './components/pages/TechniqueDetails/TechniqueDetails';
import ProgramPage from './components/pages/ProgramPage/ProgramPage';
import NuggetPage from './components/pages/NuggetPage/NuggetPage';
import NuggetDetailsPage from './components/pages/NuggetDetails/NuggetDetailsPage';
import AmritVarshaPage from './components/pages/AmritVarshaPage/AmritVarshaPage';
import AmritVarshaDetails from './components/pages/AmritVarshaDetails/AmritVarshaDetails';
import { ThemeProvider } from './components/context/ThemeContext';

function App() {
  useEffect(() => {
    console.log("APP JS");
  }, [])

  return (
    <ThemeProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Homepage />} />
          <Route path='/talks' element={<Talkpage />} />
          <Route path='/talks/:id' element={<TalkDetails />} />
          <Route path='/techniques' element={<TechniquePage />} />
          <Route path='/techniques/:id' element={<TechniqueDetails />} />
          <Route path='/programs' element={<ProgramPage />} />
          <Route path='/nuggets' element={<NuggetPage />} />
          <Route path='/nuggets/:id' element={<NuggetDetailsPage />} />
          <Route path='/amrit-varsha' element={<AmritVarshaPage />} />
          <Route path='/amrit-varsha/:id' element={<AmritVarshaDetails />} />
        </Route>
        <Route path="/submit-summary/:id" element={<SubmitSummaryPage />} />
        <Route path='/login' element={<Login />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ThemeProvider>
  );
}

export default App;